/**
 * Customer engagement telemetry — fire-and-forget pings that feed the staff
 * Customer Usage dashboard (active users, DAU, feature adoption, adoption score).
 *
 * Throttled client-side to one call per feature per 10 minutes per session
 * (the backend further dedupes to one doc per user/feature/day), so sprinkling
 * logFeature() liberally is cheap. Never throws into the UI.
 */
import { httpsCallable } from 'firebase/functions'
import { functions } from '../config'

export type Feature = 'app' | 'cockpit' | 'eligibility' | 'collection' | 'roi' | 'patients' | 'reports' | 'benefits_capture'

const THROTTLE_MS = 10 * 60 * 1000
const lastSent: Partial<Record<Feature, number>> = {}

export function logFeature(feature: Feature): void {
  const now = Date.now()
  const prev = lastSent[feature]
  if (prev && now - prev < THROTTLE_MS) return
  lastSent[feature] = now
  try {
    void httpsCallable(functions, 'logActivity')({ feature }).catch(() => {})
  } catch {
    /* never surface telemetry failures to the user */
  }
}
